import PlayCircle from './PlayCircle'
import PauseCircle from './PauseCircle'

const ProductVideo = ({
    video,
    videoIsActive,
    videoIsPlaying,
    videoRef,
    handleVideoEnd,
    handleVideoClick,
}) => {
    // console.log('videoIsActive', videoIsActive)
    return (
        <div
            className={`product-video-outer ${
                videoIsActive ? 'video-active' : ''
            } ${videoIsPlaying ? 'video-playing' : 'video-paused'}`}
        >
            <div className="product-video-inner">
                <video
                    ref={videoRef}
                    onEnded={handleVideoEnd}
                    onClick={handleVideoClick}
                >
                    <source src={video} type="video/mp4" />
                    Sorry, your browser doesn't support embedded videos.
                </video>
                <div
                    className="video-icons"
                    onClick={handleVideoClick}
                    title={videoIsPlaying ? 'Pause Video' : 'Play Video'}
                >
                    {videoIsPlaying ? <PauseCircle /> : <PlayCircle />}
                </div>
            </div>
        </div>
    )
}

export default ProductVideo
